import { useQuery } from '@tanstack/react-query';
import { get } from '@utils/axios_api';

const fetchDashboardSummary = () => get('/bizscanpro/dashboard-summary');

export function useBizDashboard() {
    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ['bizDashboardSummary'],
        queryFn: fetchDashboardSummary,
        staleTime: 60_000,
    });

    // Express API: { ok, message, summary: { total_cards, pending_review, completed, average_ocr }, recent_items }
    const raw = data?.summary ?? null;
    const summary = raw
        ? {
              total_cards:    raw.total_cards    ?? 0,
              pending_review: raw.pending_review ?? 0,
              completed:      raw.completed      ?? 0,
              average_ocr:    raw.average_ocr    ?? null,
          }
        : null;

    const recentItems = Array.isArray(data?.recent_items) ? data.recent_items : [];

    return {
        summary,
        recentItems,
        isLoading,
        isError,
        refetch,
    };
}
